module.exports = __webpack_public_path__ + "../resources/img/ic_cloudy_night_weather.38900c83.svg";